/*

& Index of every slice's default (sample) state data.

  10 Oct 2026: the delete_account slice (the old delete-link token) and the thunks and
  reducers that served the old delete flows (deleteBusinessProfile, sendDeleteBPLink) were
  removed; deletion now uses a server-sent code (lib/teams/deleteFlowsClient).

*/

/* Account Settings Page Default State Data */

export { account_settings_page } from "./account-settings-page";

/* Beegru Points Transaction Default State Data */

export { beegru_points_transaction } from "./beegru-points-transaction";

/* Bidding_cycle Default State Data */

export { bidding_cycles } from "./bidding-cycle";

/* Boost Default State Data */

export { boost } from "./boost";

/* Boost Post Page Default State Data */

export { boost_post_page } from "./boost-post-page";

/* Intro page */

export { intro } from "./intro-page";

/* Boost Service Page Default State Data */

export { boost_service_page } from "./boost-service-page";

/* Boost User Profile Page Default State Data */

export { boost_user_profile_page } from "./boost-user-profile-page";

/* Boost Business Profile Page Default State Data */

export { boost_business_profile_page } from "./boost-business-profile-page";

/* Boost Property Page Default State Data */

export { boost_property_page } from "./boost-property-page";

/*looking for home page*/
export { looking_for } from "./looking-for";

/*Boost location */
export { location_boost } from "./location-boost";

/*boost location lat and lng */
export { location } from "./location-lat-lng";

/* Business Profile Default State Data */

export { business_profile } from "./business-profile";

/* Cash Transaction Default State Data */

export { cash_transaction } from "./cash-transaction";

/* Payment Transaction Default State Data */

export { payment_transaction } from "./payment-transaction";

/* Broadcast Default State Data */

export { broadcast } from "./broadcast";

/* Broadcast Recipient Default State Data */

export { broadcast_recipient } from "./broadcast-recipient";

/* Broadcast Recipient Default State Data */

export { broadcast_data } from "./broadcast-data";

/* Chat States Default State Data */

export { chat_states } from "./chat-states";

/* Contribution Default State Data */

export { contributions } from "./contribution";

/* Faq Default State Data */

export { faq } from "./faq";

/* FAQs Page Default State Data */

export { faqs_page } from "./faqs-page";

/* Single FAQ Page Default State Data */

export { single_faq_page } from "./single-faq-page";

/* Home Page Default State Data */

export { homePage } from "./home-page";

/* Neighbourhood Reviews Page Default State Data */

export { neighbourhood_reviews_page } from "./neighbourhood-reviews-page";

/* New Property Data Default State */

export { new_property_data } from "./new-property-data";

/* New Service Data Default State */

export { new_service_data } from "./new-service-data";

/* Notification Default State Data */

export { notification_data } from "./notification";

/* Notifications Page Default State Data */

export { notifications_page } from "./notifications-page";

/* Single Business Profile Page Default State Data */

export { single_business_profile } from "./single-business-profile";

/* Single Service Page Default Data */

export { single_service_page } from "./single-service-page";

/* Single User Profile Page Default State Data */

export { single_user_profile } from "./single-user-profile";

/* Global Search Results Default State Data */

export { global_search_results } from "./global-search-results";

/* Post Default State Data */

export { post } from "./post";

/* Property Default State Data */

export { property } from "./property";

/* Single Property Default State Data */

export { single_property_page } from "./single-property-page";

/* Property Reviews Page Default Data */

export { property_reviews_page } from "./property-reviews-page";

/* Receipt Page Default State Data */

export { receipt_page } from "./receipt-page";

/* Review Default State Data */

export { review } from "./review";

/* Sevice Default State Data */

export { service } from "./service";

/* Service Reviews Page Default State Data */

export { service_reviews_page } from "./service-reviews-page";

/* User Default State Data */

export { user } from "./user";

/* Payment Data */

export { payment } from "./payment";

/* Beegru Points Data */

export { beegru_points } from "./beegru-points";

/* Transactions Default State Data */

export { transactions } from "./transactions";

/* Subscription Plans Default State Data */

export { subscription_plans } from "./subscription-plans";

/* Subscriptions Default State Data */

export { subscriptions } from "./subscriptions";

/* Session Default State Data */

export { session } from "./session";

/* Auth Log Default State Data */

export { auth_log } from "./auth-log";

/* IPStack Response Default State Data */

export { ip_stack_response } from "./ip-stack-response";

/* UserStack Response Default State Data */

export { user_stack_response } from "./user-stack-response";

/* Profile Context Default State Data */

export { profile_context } from "./profile-context";

/* Search Query Default State Data */

export { search_query } from "./search-query";

/* Is Searching Default State Data */

export { is_searching } from "./is-searching";

/* Search results page number Default State Data */

export { search_results_page_number } from "./search_results_page_number";

/* Is Loading Default State Data */

export { is_loading } from "./is-loading";

/* Open post modal State Data */

export { open_post_modal } from "./open-post-modal";

/* Property loading default state data */

export { property_loading } from "./property-loading";

/* Property Snackbar default state data */

export { property_snackbar } from "./property-snackbar";

/* service snackbar default state data */

export { service_snackbar } from "./service-snackbar";

/* Account Setting Snackbar default state data */

export { accountsetting_snackbar } from "./account-setting-snackbar";

/* Service loading default state data */

export { service_loading } from "./service-loading";

/* zgory Default State Data */

export { category } from "./category";

/* Action for booms Default State Data */

export { actionForBooms } from "./action-for-booms";

export { cta_leads } from "./cta-leads";

/* Single post page default data */

export { single_post_page } from "./single-post-page";

/* New Listing URL Default State Data */

export { new_listing_url } from "./new_listing_url";

/* New Business Profile URL Default State Data */

export { new_business_profile_url } from "./new_business_profile_url";

/* Property List Default State Data */

export { property_list } from "./property-list-data";

/* service List Default State Data */

export { service_list } from "./service-list-data";

/* ofb List Default State Data */

export { ofb_list } from "./ofb-list-data";

/* Saved Property List Default State Data */

export { saved_properties_list } from "./saved-property-list-data";

/* Saved services List Default State Data */

export { saved_services_list } from "./saved-services-list-data";

/* Saved posts List Default State Data */

export { saved_posts_list } from "./saved-posts-list-data";

/* Saved OFB List Default State Data */

export { saved_ofb_list } from "./saved-ofb-list-data";

/* Helper Text Default State Data */

export { bug_report } from "./bug-report";

/* Verify email Default State Data  */

export { verify_email } from "./verify-email";

/* Activity Log Default State Data */

export { activity_log } from "./activity-log";

/* Report Default State Data */

export { report } from "./report";

/* manual beegru points Default State Data */

export { manual_beegru_points } from "./manual-beegru-points";

/* employee default state data */

export { employee } from "./employee";

/* Section to edit default state data */

export { section_to_edit } from "./section-to-edit";

/* Data before edit default state data */

export { data_before_edit } from "./data-before-edit";

/* Home Loading default state data */

export { home_loading } from "./home-loading";

/* Business profile listings tab view default state data */

export { business_profile_listings_tab_view } from "./business_profile_listings_tab_view";

/* Business profile snackbar default state data */

export { business_profile_snackbar } from "./business-profile-snackbar";

/* Business Profile loading default state data */

export { business_profile_loading } from "./business-profile-loading";

/* Home page loaction */

export { home_location } from "./home-location";

/* User profile loading */

export { user_profile_loading } from "./user-profile-loading-data";

/* Notifications loading */

export { notifications_loading } from "./notifications-loading";

/* Account Setting loading */

export { account_setting_loading } from "./account-setting-loading";

/* Chat Default Data */

export { chat } from "./chat";

/* Chat Message Default Data */

export { chat_message } from "./chat-message";

/* Transaction type for home tabs */

export { transaction } from "./transaction-tabs";

/* on boarding details */

export { on_boarding_details } from "./on-boarding-details";

/* on boarding title*/

export { on_boarding_title } from "./on-boarding-title";

/* User profile snackbar default state data */

export { user_profile_snackbar } from "./user-profile-snackbar";

/* Boost Pricing Manual Override */

export { boost_pricing_manual_override } from "./boost-pricing-manual-override";

/* Bottom Subscribe Buy Beegru Points */

export { bottom_subscribe_buy_beegru_points } from "./bottom-subscribe-buy-beegru-points";

/* DLT Template Default State Data */

export { dlt_template } from "./dlt-template";

/* DLT SMS Record Default State Data */

export { dlt_sms_record } from "./dlt-sms-record";

/* Redux Session Default State Data */

export { redux_session } from "./redux-session";

/* OTP Default State Data */

export { otp } from "./otp";

/* Properties Price Tracker Default State Data */

export { properties_price_tracker } from "./properties-price-tracker";

/* services Price Tracker Default State Data */

export { services_price_tracker } from "./services-price-tracker";

/* location tracker default data */


/* search filters metrices default data */

export { search_filter_metrices } from "./search-filter-metrices";

/* Search animation settings */

export { search_animation_settings } from "./search-animation-settings";

/* Search Filter Api Response State */

export { SeacrhApiResponse } from "./search-api-response";

/* Property Status History Default State Data */

export { property_status_history } from "./property-status-history";

/* service Status History Default State Data */

export { service_status_history } from "./service-status-history";

/* loading default state data */

export { loading } from "./loading";

/* Localities Default State Data */

export { localities } from "./localities";

/* Business Dashboard Default State Data */

export { business_dashboard } from "./business-dashboard";

/* Saved Items Default State Data */

export { saved_items } from "./saved-items";

/*Shares Default State Data */

export { shares } from "./shares";

/* Rewards Default State Data */

export { rewards } from "./rewards";

/* Login Flow Global State Default State Data */

export { login_flow_global_state } from "./login-flow-global-state";

/*  Meta Campaign Default State Data */

export { meta_campaign } from "./meta-campaign";

/* AI Boosts Leads Default State Data */

export { ai_boost_leads } from "./ai-boost-leads";

/* AI Boosts Default State Data */

export { ai_boosts } from "./ai-boosts";

/* AI boost meta campaign Data*/

export { ai_boost_meta_campaign } from "./ai-boost-meta-campaign";

/* AI boost google campaign Data*/

export { ai_boost_google_campaign } from "./ai-boost-google-campaign";

/* AI boost google ad group data */

export { ai_boost_google_ad_group } from "./ai-boost-google-ad-group";

/* AI boost google ad data */

export { ai_boost_google_ad } from "./ai-boost-google-ad";

/* Feature Discovery Tracker Default State Data */

export { feature_discovery_tracker } from "./feature-discovery-tracker";

export { ai_boost_agent_output_meta_optimization_graph } from "./ai-boost-agent-output-meta-optimization-graph";

/* AI Boost B2B Leads Default State Data */

export { ai_boost_b2b_leads } from "./ai-boost-b2b-leads";

/* AI Boost Meta Ads Default State Data */

export { ai_boost_meta_ads } from "./ai-boost-meta-ads";

/* AI Boost Change Logs Default State Data */

export { ai_boosts_change_logs } from "./ai-boosts-change-logs";

/* AI Boost Adset Default State Data */

export { ai_boost_meta_adsets } from "./ai-boost-meta-ad-sets";

/* Sales Support Investment Default State Data */

export { sales_support_investment } from "./sales-support-investment";

/* Property Closure Default State Data */

export { property_closure } from "./property-closure";

/* Home Page Stats Default State Data */

export { home_page_stats } from "./home-page-stats";

/* Sort By Default State Data */

export { search_sort_by } from "./search-sort-by";

/* Ner Search State Data */

export { ner_search_states } from "./ner-search-states";

/* Client CRM Integration Webhooks Default State Data */

export { client_crm_integration_webhooks } from "./client-crm-integration-webhooks";

/* Test Client CRM Integration Webhooks Default State Data */

export { test_client_crm_integration_webhooks } from "./test-client-crm-integration-webhooks";

/* Business profile activity logs Default state data */

export { business_profile_activity_logs } from "./business-profile-activity-logs";

/* Team Invite Default State Data */

export { team_invite } from "./team-invite";

/* Requirement Default State Data */

export { requirement } from "./requirement";

/* Requirements Feed Default State Data */

export { requirements_feed } from "./requirements-feed";

/* My Requirements Default State Data */

export { my_requirements } from "./my-requirements";

/* Property Translations Default State Data */

export { property_translations } from "./property-translations";

/* BBM Push Notification Template Default State Data */

export { bbm_push_notification_template } from "./bbm-push-notification-template";

/* BBM Scheduled Push Notification Log Default State Data */

export { bbm_scheduled_push_notification_log } from "./bbm-scheduled-push-notification-log";

/* Notification Queue Default State Data */

export { notification_queue } from "./notification-queue";
